module.exports = __webpack_public_path__ + "img/HC1029-76.84acb9f1.jpg";